const languagesList: string[] = ['it-IT', 'en-US'];
export { languagesList };

